import { render, staticRenderFns } from "./QResourceMenuCss.vue?vue&type=template&id=c3245d68&"
import script from "./QResourceMenuCss.vue?vue&type=script&lang=js&"
export * from "./QResourceMenuCss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports